var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5807 15.3499L8.51172 13.3999V27.8089C8.51159 27.9655 8.54237 28.1206 8.6023 28.2653C8.66223 28.41 8.75014 28.5414 8.86097 28.6521C8.9718 28.7627 9.10338 28.8504 9.24817 28.9101C9.39296 28.9698 9.54811 29.0003 9.70472 28.9999H28.8047C28.9615 29.0006 29.1169 28.9702 29.2619 28.9107C29.4069 28.8511 29.5387 28.7635 29.6498 28.6528C29.7608 28.5421 29.8489 28.4106 29.9089 28.2658C29.969 28.1209 29.9999 27.9657 29.9997 27.8089V22.4999L19.5807 15.3499Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5807 3H9.70472C9.54811 2.99961 9.39296 3.03013 9.24817 3.08982C9.10338 3.14951 8.9718 3.23719 8.86097 3.34784C8.75014 3.45848 8.66223 3.58992 8.6023 3.73461C8.54237 3.8793 8.51159 4.03439 8.51172 4.191V9.5L19.5807 16L25.4417 17.95L29.9997 16V9.5L19.5807 3Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51172 9.5H19.5807V16H8.51172V9.5Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.4337 8.2002H8.51172V24.4502H16.4337C16.7494 24.4486 17.0517 24.3227 17.2752 24.0998C17.4987 23.8769 17.6254 23.5749 17.6277 23.2592V9.3912C17.6254 9.07553 17.4987 8.77352 17.2752 8.55059C17.0517 8.32765 16.7494 8.20176 16.4337 8.2002Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.7827 8.8501H8.51172V25.1001H15.7827C16.0984 25.0985 16.4007 24.9726 16.6242 24.7497C16.8477 24.5268 16.9744 24.2248 16.9767 23.9091V10.0411C16.9744 9.72544 16.8477 9.42342 16.6242 9.20049C16.4007 8.97756 16.0984 8.85167 15.7827 8.8501Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.7827 8.8501H8.51172V23.8001H15.7827C16.0984 23.7985 16.4007 23.6726 16.6242 23.4497C16.8477 23.2268 16.9744 22.9248 16.9767 22.6091V10.0411C16.9744 9.72544 16.8477 9.42342 16.6242 9.20049C16.4007 8.97756 16.0984 8.85167 15.7827 8.8501Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.1317 8.8501H8.51172V23.8001H15.1317C15.4474 23.7985 15.7497 23.6726 15.9732 23.4497C16.1967 23.2268 16.3234 22.9248 16.3257 22.6091V10.0411C16.3234 9.72544 16.1967 9.42342 15.9732 9.20049C15.7497 8.97756 15.4474 8.85167 15.1317 8.8501Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.194 8.8501H15.132C15.4482 8.84984 15.7516 8.97514 15.9755 9.19846C16.1994 9.42179 16.3255 9.72487 16.326 10.0411V21.9591C16.3255 22.2753 16.1994 22.5784 15.9755 22.8017C15.7516 23.0251 15.4482 23.1504 15.132 23.1501H3.194C3.03731 23.1506 2.88205 23.1202 2.73715 23.0606C2.59224 23.0009 2.46054 22.9133 2.3496 22.8026C2.23866 22.692 2.15067 22.5605 2.09068 22.4157C2.03068 22.271 1.99987 22.1158 2 21.9591V10.0411C1.99987 9.88441 2.03068 9.72923 2.09068 9.58448C2.15067 9.43972 2.23866 9.30824 2.3496 9.19758C2.46054 9.08692 2.59224 8.99926 2.73715 8.93963C2.88205 8.88 3.03731 8.84958 3.194 8.8501Z",
    fill: "url(#paint0_linear_4012_76337)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69922 19.873L8.21022 15.989L5.91022 12.127H7.75722L9.01222 14.6C9.12822 14.834 9.21222 15.008 9.25022 15.124H9.26722C9.34922 14.9366 9.43589 14.7546 9.52722 14.578L10.8692 12.131H12.5692L10.2102 15.971L12.6292 19.876H10.8202L9.37022 17.165C9.30309 17.0483 9.24588 16.9262 9.19922 16.8H9.17522C9.13284 16.923 9.07647 17.0408 9.00722 17.151L7.51422 19.873H5.69922Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8051 3.00001H19.5801V9.50001H29.9991V4.19101C29.9992 4.03431 29.9684 3.87913 29.9084 3.73438C29.8484 3.58963 29.7604 3.45815 29.6495 3.34749C29.5385 3.23682 29.4068 3.14916 29.2619 3.08953C29.117 3.0299 28.9618 2.99948 28.8051 3.00001Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5801 16H29.9991V22.5H19.5801V16Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4012_76337",
    x1: 4.494,
    y1: 7.9141,
    x2: 13.832,
    y2: 24.0861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXls);
export default __webpack_public_path__ + "static/media/icon-xls.b8ffa9bb1e9ad519bc0b3fa8dade3ce3.svg";
export { ForwardRef as ReactComponent };